(function () {
  if (window.cardSwiperInitialised) return;
  window.cardSwiperInitialised = true;

  function initSwiper(scope, force) {
    (scope || document).querySelectorAll('.product-card__media.swiper-container').forEach(function (container) {
      if (window.isCollectionPage && container.closest('main')) return;
      if (container.swiper) {
        if (!force) return;
        container.swiper.destroy(true, true);
      }

      var productId = container.dataset.productId;
      var currentVariantId = window.productVariants ? window.productVariants[productId] : null;
      var slides = container.querySelectorAll('.swiper-slide');
      var initialSlide = 0;

      slides.forEach(function (slide, index) {
        if (!slide.classList.contains('swiper-slide--variant')) return;
        if (currentVariantId && slide.dataset.variantId === currentVariantId) {
          initialSlide = index;
        }
      });

      var autoplay = container.dataset.autoplay === 'true';

      var config = {
        slidesPerView: 1,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        loop: slides.length > 1,
        initialSlide: initialSlide,
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev')
        },
        lazy: true
      };

      if (autoplay) {
        config.autoplay = { delay: 5000, disableOnInteraction: false };
        config.effect = 'fade';
        config.fadeEffect = { crossFade: true };
      }

      new Swiper(container, config);
    });
  }

  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (radio.type !== 'radio' || !radio.hasAttribute('data-variant-id')) return;

    var card = radio.closest('product-card');
    if (!card) return;

    if (window.isCollectionPage && card.closest('main')) return;

    var container = card.querySelector('.product-card__media.swiper-container');
    if (!container || !container.swiper) return;

    var swiper = container.swiper;
    var variantId = radio.getAttribute('data-variant-id');
    var slide = Array.prototype.find.call(swiper.slides, function (s) {
      return !s.classList.contains('swiper-slide-duplicate') && s.dataset.variantId === variantId;
    });

    if (slide) swiper.slideToLoop(Number(slide.dataset.swiperSlideIndex));
  });

  document.addEventListener('DOMContentLoaded', function () { initSwiper(document, true); });
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { initSwiper(document, true); }, 150); });

  var timer;
  var observer = new MutationObserver(function (mutations) {
    var added = mutations.some(function (m) {
      return Array.prototype.some.call(m.addedNodes, function (node) {
        return node.nodeType === 1 &&
          ((node.classList && node.classList.contains('swiper-container')) ||
           (node.querySelector && node.querySelector('.swiper-container')));
      });
    });
    if (!added) return;
    clearTimeout(timer);
    timer = setTimeout(function () { initSwiper(document, false); }, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();